import { ExportJobDTO, ExportJobStatus, ExportJobType, ReportFileType } from "src/app/base/models/models.swagger.generated";
import { ExportJobService } from "./export-job.service";

export const StatusClassMap = new Map<ExportJobStatus, string>([
    [ExportJobStatus.NotStarted, 'e-pending'],
    [ExportJobStatus.InProgress, 'e-info'],
    [ExportJobStatus.Completed, 'e-success'],
    [ExportJobStatus.Error, 'e-danger']
]);

export function getStatusClassName(status: ExportJobStatus): string {
    return StatusClassMap.get(status) || 'e-warning';
}

export const ExtensionMap = new Map<ExportJobType, string>([
    [ExportJobType.ParkerExtract, '.docx'],
    [ExportJobType.ParkerExtractSAP, '.txt,.csv']
]);

export function getAllowedFileExtensions(jobType: ExportJobType): string {
    return ExtensionMap.get(jobType) || '';
}

export function downloadFile(exportJob: ExportJobDTO,  exportJobService: ExportJobService): void {
    if (exportJob.id) {
        exportJobService.downloadOutputFile(exportJob.id).subscribe({
            next: (blob: Blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const fileExtension = getFileExtension(exportJob);
                a.download = `export-job-${exportJob.id}.${fileExtension}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        });
    }
}

export function getFileExtension(exportJob: ExportJobDTO): string {
    if (exportJob.fileType === ReportFileType.PDF) {
        return 'zip';
    } else if (exportJob.fileType === ReportFileType.CSV) {
        return 'csv';
    } else {
        return '';
    }
}